var map = {
	"./777.png": "3678",
	"./888-logos.png": "c70f",
	"./888casino.png": "49f4",
	"./888sport.png": "a9a0",
	"./about-in-app.svg": "b7fd",
	"./activity.png": "778a",
	"./adcolony.png": "c303",
	"./additional-traffic-logo/Apple_logo_black.svg": "5a31",
	"./additional-traffic-logo/Baidu-01.svg": "7a63",
	"./additional-traffic-logo/MOLOKO.svg": "f7f5",
	"./additional-traffic-logo/ShareIt-app.svg": "15a4",
	"./additional-traffic-logo/Simeji-wh-app.svg": "30ed",
	"./additional-traffic-logo/Vungle-app.svg": "4ae0",
	"./additional-traffic-logo/adcolony-icon.svg": "1f23",
	"./additional-traffic-logo/applovin-app.svg": "e3cd",
	"./additional-traffic-logo/bigo-ads-app.svg": "4ecd",
	"./additional-traffic-logo/criteo-app.svg": "28e9",
	"./additional-traffic-logo/facebook.svg": "55e0",
	"./additional-traffic-logo/google-ads-app.svg": "a05a",
	"./additional-traffic-logo/google-display-and-video-ads.svg": "4ce4",
	"./additional-traffic-logo/inst.png": "f777",
	"./additional-traffic-logo/ironSource-app.svg": "3fae",
	"./additional-traffic-logo/ironSourceAura-app.svg": "8c55",
	"./additional-traffic-logo/mytarget-app.svg": "04a2",
	"./additional-traffic-logo/snapchat.svg": "8953",
	"./additional-traffic-logo/tiktok.svg": "04b9",
	"./additional-traffic-logo/twitter-app.svg": "7398",
	"./additional-traffic-logo/unity.svg": "d782",
	"./additional-traffic-logo/xiaomi.svg": "552c",
	"./advantages-bg-mobile.png": "a849",
	"./advantages-bg-mobile.svg": "8b3f",
	"./advantages-bg.png": "a70e",
	"./appsflyer.png": "df64",
	"./arrow-left-white.svg": "507d",
	"./arrow-right-white.svg": "8640",
	"./arrow-up.svg": "c033",
	"./astronaut.png": "8c1b",
	"./automation.png": "33a5",
	"./awaeds-bottom.svg": "a99c",
	"./bet365-logos.png": "9b98",
	"./bet365.png": "31d6",
	"./betway-sports.png": "29c0",
	"./bingo.png": "412e",
	"./burger.svg": "4a3d",
	"./bv.png": "7d1a",
	"./chevron-left.svg": "5397",
	"./chevron-right.svg": "4308",
	"./clients-bg-left.png": "d2db",
	"./clients-bg-right.png": "4bea",
	"./clients-slider-bg-mobile.png": "1999",
	"./clients-slider-bg.png": "8283",
	"./clients/client1.png": "ab63",
	"./clients/client10.png": "ef1a",
	"./clients/client11.png": "7894",
	"./clients/client13.png": "11d2",
	"./clients/client2.png": "e45a",
	"./clients/client3.png": "b9a0",
	"./clients/client4.png": "c33d",
	"./clients/client7.png": "10f7",
	"./close.svg": "2930",
	"./contacts-header-bg-mobile.png": "b3e4",
	"./contacts-header-bg.png": "3d04",
	"./coral.png": "c2e8",
	"./double-chevron-left.svg": "66fe",
	"./double-chevron-right.svg": "e13f",
	"./effie-awards-logo.svg": "9730",
	"./entain-logos.png": "13cd",
	"./envelop.svg": "46be",
	"./facebook.svg": "44c6",
	"./fb-blue.png": "b4d5",
	"./form-bg-red.png": "a9e4",
	"./form-bg-white.png": "1f6d",
	"./gala-casino.png": "ed86",
	"./game.png": "acc1",
	"./gb.png": "e3bf",
	"./genesis-casino.png": "fcc1",
	"./ghost.png": "94c5",
	"./google-ads.png": "8358",
	"./google.svg": "b5df",
	"./grosvenor-casinos.png": "a0b7",
	"./header-bg-mobile.png": "f406",
	"./header-bg.png": "206d",
	"./hill-casino.png": "e4b6",
	"./hill-vegas.png": "7e08",
	"./hill.png": "8f97",
	"./icons-set.svg": "00a1",
	"./inapp-bg.png": "caa3",
	"./inapp-bg2.png": "7d43",
	"./inapp-logos.png": "aeb5",
	"./inst.png": "46b9",
	"./instagram.svg": "d91d",
	"./ireland.png": "3f3b",
	"./journey-bg.png": "7574",
	"./l-large.png": "b85c",
	"./l.png": "5ddf",
	"./l2.png": "2ee2",
	"./leaf.png": "d329",
	"./linkedin.svg": "6a55",
	"./logo-footer.png": "6331",
	"./logo-title.png": "ba43",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./m-bet.png": "e5c5",
	"./mansion-logos.png": "df78",
	"./my.png": "8155",
	"./party-casino.png": "9572",
	"./phone1.png": "ad10",
	"./phone2.png": "ab80",
	"./phone3.png": "90e6",
	"./play.png": "c4bf",
	"./points-bet-large.png": "5722",
	"./points-bet.png": "b8f9",
	"./portugal.png": "d055",
	"./red-diamond.png": "7572",
	"./red-romb.png": "857a",
	"./shield.png": "b942",
	"./space-bg-mobile.png": "ca45",
	"./space-bg.png": "6a31",
	"./spain.png": "f9d0",
	"./star-small.png": "4e85",
	"./star.png": "adfd",
	"./stars.svg": "d1a4",
	"./sweden.png": "4002",
	"./three-colors.png": "d5ac",
	"./twitter.png": "9284",
	"./unity-ads.png": "ebc3",
	"./us.png": "5916",
	"./user-acquasition-bg-mobile.png": "b3a9",
	"./user-acquasition-bg.png": "37a4",
	"./vungle.svg": "1105",
	"./we-trusted/partner-1.png": "902b",
	"./we-trusted/partner-10.png": "2875",
	"./we-trusted/partner-11.png": "f8f3",
	"./we-trusted/partner-13.jpg": "12be",
	"./we-trusted/partner-14.jpg": "4789",
	"./we-trusted/partner-2.png": "0aca",
	"./we-trusted/partner-4.png": "c6e0",
	"./we-trusted/partner-6.png": "3b3d",
	"./we-trusted/partner-7.png": "1037",
	"./we-trusted/partner-9.png": "398c",
	"./william-logos.png": "b2e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";